export default __webpack_public_path__ + "720bea9faca5ee09d3debfbc75e7a030.png";